// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "quill" + "." + "ad086f94ec4fa61b" + ".js";
};